import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { switchMap, take, map } from 'rxjs/operators';

import { TagsService } from '@app/tags/services/tags.service';

import { UserInterest } from '@app/user/user-api.model';
import { DfIconPlusOutline16, DfIconRegistry } from '@lib/fresco';

@Injectable()
export class LearnerHomeFocusSkillsService implements OnDestroy {
  /** Call next on this to refresh focus skill data */
  public refresh$ = new BehaviorSubject<UserInterest[]>(null);

  /** Subscribe to this observable to get the latest focus skills */
  public focusSkills$ = this.refresh$.pipe(
    switchMap(() => this.loadFocusSkills$)
  );

  private loadFocusSkills$: Observable<UserInterest[]> = this.tagsService
    .getUserTopTags(true, false, true)
    .pipe(
      take(1),
      map((data) => {
        // sort focus skills by last modified to match the profile skills tab sort
        return data
          .slice()
          .sort(
            (a, b) =>
              new Date(b.dateModified).getTime() -
              new Date(a.dateModified).getTime()
          );
      })
    );

  private events: Subscription;

  constructor(
    private tagsService: TagsService,
    private iconRegistry: DfIconRegistry
  ) {
    this.iconRegistry.registerIcons([DfIconPlusOutline16]);
    // Refresh focus skills when user tags are updated
    this.events = this.tagsService.userTagsModified.subscribe(() =>
      this.refresh$.next(null)
    );
  }

  public ngOnDestroy(): void {
    this.events.unsubscribe();
  }
}
